import { store } from '~/store';

export const setCurrentUser = user => store.dispatch('auth/setUser', user);
export const setLoginType = type => store.dispatch('auth/setLoginType', type);
export const setApiKey = key => store.dispatch('auth/setKey', key);
export const setApiUrl = url => store.dispatch('apiUrl/setUrl', url);
export const initDycolor = (name, scss) => store.dispatch('dycolor/updateComponentCss', { name, css: scss[0][1] });
export const updateClientColors = colors => store.dispatch('dycolor/updateClientColors', colors);
export const setInterfaceLanguage = lang => store.dispatch('i18n/setInterfaceLanguage', lang);



// WEBPACK FOOTER //
// ./src/gotu-vue-common/src/store/actions.js